import React, { useState } from 'react';
import {
  Box,
  Button,
  HStack,
  Text,
  Badge,
  IconButton,
  Table,
} from '@chakra-ui/react';
import { FiPlus, FiMapPin, FiEdit2, FiTrash2 } from 'react-icons/fi';
import { PageWrapper } from '../components/PageWrapper';
import { EmptyState } from '../components/EmptyState';

interface Location {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
  timestamp: string;
  accuracy: number;
  shared: boolean;
}

function LocationsPage() {
  const [locations, setLocations] = useState<Location[]>([
    {
      id: '1',
      name: 'Home',
      latitude: 37.7749,
      longitude: -122.4194,
      timestamp: new Date().toISOString(),
      accuracy: 10,
      shared: true
    },
    {
      id: '2',
      name: 'Office',
      latitude: 37.7858,
      longitude: -122.4065,
      timestamp: new Date(Date.now() - 3600000).toISOString(),
      accuracy: 15,
      shared: false
    },
    {
      id: '3',
      name: 'Coffee Shop',
      latitude: 37.7694,
      longitude: -122.4862,
      timestamp: new Date(Date.now() - 7200000).toISOString(),
      accuracy: 20,
      shared: true
    }
  ]);


  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };
  
  const addDummyLocation = () => {
    const newLocation: Location = {
      id: crypto.randomUUID(),
      name: `Location ${locations.length + 1}`,
      latitude: 37.7749 + (Math.random() - 0.5) * 0.1,
      longitude: -122.4194 + (Math.random() - 0.5) * 0.1,
      timestamp: new Date().toISOString(),
      accuracy: Math.floor(Math.random() * 30) + 5,
      shared: Math.random() > 0.5
    };
    setLocations([...locations, newLocation]);
  };

  return (
    <PageWrapper>
      <HStack justify="space-between">
        <Text fontSize="2xl" fontWeight="bold">Locations</Text>
        <Button
          colorPalette="blue"
          onClick={addDummyLocation}
        >
          <FiPlus /> Add Location
        </Button>
      </HStack>

          <Box overflowX="auto">
            <Table.Root>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeader>Name</Table.ColumnHeader>
                  <Table.ColumnHeader>Coordinates</Table.ColumnHeader>
                  <Table.ColumnHeader>Accuracy</Table.ColumnHeader>
                  <Table.ColumnHeader>Timestamp</Table.ColumnHeader>
                  <Table.ColumnHeader>Status</Table.ColumnHeader>
                  <Table.ColumnHeader>Actions</Table.ColumnHeader>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {locations.map((location) => (
                  <Table.Row key={location.id}>
                    <Table.Cell>
                      <HStack>
                        <FiMapPin />
                        <Text fontWeight="medium">{location.name}</Text>
                      </HStack>
                    </Table.Cell>
                    <Table.Cell>
                      <Text fontSize="sm" fontFamily="mono">
                        {location.latitude.toFixed(4)}, {location.longitude.toFixed(4)}
                      </Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Text fontSize="sm">{location.accuracy}m</Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Text fontSize="sm">{formatTimestamp(location.timestamp)}</Text>
                    </Table.Cell>
                    <Table.Cell>
                      <Badge colorPalette={location.shared ? 'green' : 'gray'}>
                        {location.shared ? 'Shared' : 'Private'}
                      </Badge>
                    </Table.Cell>
                    <Table.Cell>
                      <HStack gap={1}>
                        <IconButton
                          aria-label="Edit location"
                          size="sm"
                          variant="ghost"
                        >
                          <FiEdit2 />
                        </IconButton>
                        <IconButton
                          aria-label="Delete location"
                          size="sm"
                          variant="ghost"
                          colorPalette="red"
                        >
                          <FiTrash2 />
                        </IconButton>
                      </HStack>
                    </Table.Cell>
                  </Table.Row>
                ))}
                {locations.length === 0 && (
                  <EmptyState
                    colSpan={6}
                    message="No locations yet. Create your first location to get started."
                  />
                )}
              </Table.Body>
            </Table.Root>
          </Box>
    </PageWrapper>
  );
}

export default LocationsPage;